import React          from 'react';
import { ClipLoader } from 'react-spinners';

class Required extends React.Component {

  render() {
    return (
      <div style={{ marginRight: 'auto', marginLeft: 'auto', width: '5em' }}>
        <ClipLoader
          color={'#072659'} 
          loading={true}
          size={60}
        />
      </div>
    );
  }
}

export default Required;
